import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const deleteAddress = (state) => {

  return axios.delete(API + "parties/address-delete/"+state+"/",{headers: authHeader(),});
};
const ActiveAddress = (state) => {

  return axios.delete(API + "parties/address-active/"+state+"/",{headers: authHeader(),});
};
const InActiveAddress = (state) => {

  return axios.delete(API + "parties/address-inactive/"+state+"/",{headers: authHeader(),});
};
const DeleteAddressService = {
    deleteAddress,
    ActiveAddress,
    InActiveAddress
  };
  export default DeleteAddressService;